module.exports = __webpack_public_path__ + "static/icons/snowing@2x-d1ac898c932d96cec0c6af38bb88bc59.png";